// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-I":"I_solar-60w-I__73vp1"};